import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
const InnovationOfferings = () => {
   const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className="px-2 sm:px-12 py-6 bg-white">
        <div
            ref={title.ref}
            className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
    <h2
          className="
            text-primary font-semibold leading-tight
            text-[1.6rem]
            sm:text-[2.1rem]
            md:text-[2.5rem]
            lg:text-[2.8rem]
            xl:text-[3rem]
            mb-4 sm:mb-5
            text-center
          "
        >
       Our Flagship Offerings
      </h2>
</div>
      <p className="text-center max-w-2xl mx-auto text-gray-500 mb-4 mt-4">
        Purpose-built orthopedic solutions that unite clinical expertise,
        advanced technology, and patient-focused design.
      </p>

      <div className="max-w-5xl mx-auto">
        <div className="bg-[#F6F7F7] rounded-2xl border border-gray-200 p-8 shadow-sm transition">
          <span className="inline-block mb-4 text-xs font-semibold text-primary bg-primary/10 px-3 py-1 rounded-full">
            Custom Immobilization
          </span>

          <h3 className="text-xl font-semibold mb-1">YESOAIR</h3>
          <p className="text-xs text-gray-500 mb-5">For orthopedic clinics.</p>

          <p className="text-text-secondary leading-relaxed mb-6">
            YESOAIR transforms traditional casting through precision 3D printing
            and clinical insight. Each cast is digitally modeled to the
            patient’s anatomy for superior comfort and recovery outcomes.
          </p>

          <ul className="text-sm text-gray-600 space-y-3 mb-8">
            <li>• Anatomically personalized fit</li>
            <li>• Lightweight, breathable construction</li>
            <li>• Supports faster mobility recovery</li>
          </ul>

          <div className="flex justify-between items-center">
            <span className="text-xs text-gray-500">
              Post-fracture & rehabilitation care
            </span>
            {/* <button className="text-sm font-medium text-primary hover:underline">
              Discover the technology →
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovationOfferings;
